module.exports = __webpack_public_path__ + "static/media/linkedIn.f7cd96ba.svg";